// @ts-check
import React from 'react';
import NewReferralProfileForm from 'agent_portal/components/NewReferralProfileForm';
import { browserHistory } from 'react-router';
import api from 'utils/api';
import { Row, Widget } from 'shared/containers/portal_layout';

/**
 * Format and send the API request to create a new ReferralProfile
 * @param {FormData} formData
 * @returns {Promise}
 */
const createReferralProfile = formData =>
  api.post(`/agent_portal/api/referral_profiles`, formData).then(response => {
    browserHistory.push(
      `/a/portal/referral_profiles/${response.data.referralProfile.id}/referral_questionnaire`
    );
    return null;
  });

const New = props => (
  <Row>
    <Widget span={12} title="Patient Information" nopadding>
      <NewReferralProfileForm
        key={props.location.query.uid}
        formName={`referralProfile-${props.location.query.uid}`}
        initialSpecialtyId={props.location.query.specialty_id}
        existingPatientId={props.location.query.existing_patient_id}
        selectedNetworkId={props.location.query.selected_network_id}
        onSubmit={createReferralProfile}
      />
    </Widget>
  </Row>
);

export default New;
